// src/signals/trip-created.ts
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
import { Signal } from "@shared-ui/core-signal-manager/spi";
var TripCreatedSignal = /*#__PURE__*/ function(Signal) {
    "use strict";
    _inherits(TripCreatedSignal, Signal);
    function TripCreatedSignal() {
        _class_call_check(this, TripCreatedSignal);
        return _call_super(this, TripCreatedSignal, arguments);
    }
    return TripCreatedSignal;
}(Signal);
// src/signals/trip-entity-data-updated.ts
import { Signal as Signal2 } from "@shared-ui/core-signal-manager/spi";
var TripEntityDataUpdatedSignal = /*#__PURE__*/ function(Signal2) {
    "use strict";
    _inherits(TripEntityDataUpdatedSignal, Signal2);
    function TripEntityDataUpdatedSignal() {
        _class_call_check(this, TripEntityDataUpdatedSignal);
        return _call_super(this, TripEntityDataUpdatedSignal, arguments);
    }
    return TripEntityDataUpdatedSignal;
}(Signal2);
// src/signals/trip-item-comment-count-changed.ts
import { Signal as Signal3 } from "@shared-ui/core-signal-manager/spi";
var TripItemCommentCountChangedSignal = /*#__PURE__*/ function(Signal3) {
    "use strict";
    _inherits(TripItemCommentCountChangedSignal, Signal3);
    function TripItemCommentCountChangedSignal() {
        _class_call_check(this, TripItemCommentCountChangedSignal);
        return _call_super(this, TripItemCommentCountChangedSignal, arguments);
    }
    return TripItemCommentCountChangedSignal;
}(Signal3);
// src/signals/trip-item-comment-changed.ts
import { Signal as Signal4 } from "@shared-ui/core-signal-manager/spi";
var TripItemCommentChangedSignal = /*#__PURE__*/ function(Signal4) {
    "use strict";
    _inherits(TripItemCommentChangedSignal, Signal4);
    function TripItemCommentChangedSignal() {
        _class_call_check(this, TripItemCommentChangedSignal);
        return _call_super(this, TripItemCommentChangedSignal, arguments);
    }
    return TripItemCommentChangedSignal;
}(Signal4);
// src/signals/trip-item-count-changed.ts
import { Signal as Signal5 } from "@shared-ui/core-signal-manager/spi";
var TripItemCountChangedSignal = /*#__PURE__*/ function(Signal5) {
    "use strict";
    _inherits(TripItemCountChangedSignal, Signal5);
    function TripItemCountChangedSignal() {
        _class_call_check(this, TripItemCountChangedSignal);
        return _call_super(this, TripItemCountChangedSignal, arguments);
    }
    return TripItemCountChangedSignal;
}(Signal5);
// src/signals/trip-item-customer-notification.ts
import { Signal as Signal6 } from "@shared-ui/core-signal-manager/spi";
var TripItemCustomerNotificationSignal = /*#__PURE__*/ function(Signal6) {
    "use strict";
    _inherits(TripItemCustomerNotificationSignal, Signal6);
    function TripItemCustomerNotificationSignal() {
        _class_call_check(this, TripItemCustomerNotificationSignal);
        return _call_super(this, TripItemCustomerNotificationSignal, arguments);
    }
    return TripItemCustomerNotificationSignal;
}(Signal6);
// src/signals/trip-item-dates-changed.ts
import { Signal as Signal7 } from "@shared-ui/core-signal-manager/spi";
var TripItemDatesChangedSignal = /*#__PURE__*/ function(Signal7) {
    "use strict";
    _inherits(TripItemDatesChangedSignal, Signal7);
    function TripItemDatesChangedSignal() {
        _class_call_check(this, TripItemDatesChangedSignal);
        return _call_super(this, TripItemDatesChangedSignal, arguments);
    }
    return TripItemDatesChangedSignal;
}(Signal7);
// src/signals/trip-item-saved.ts
import { Signal as Signal8 } from "@shared-ui/core-signal-manager/spi";
var TripItemSavedSignal = /*#__PURE__*/ function(Signal8) {
    "use strict";
    _inherits(TripItemSavedSignal, Signal8);
    function TripItemSavedSignal() {
        _class_call_check(this, TripItemSavedSignal);
        return _call_super(this, TripItemSavedSignal, arguments);
    }
    return TripItemSavedSignal;
}(Signal8);
// src/signals/trip-item-unsaved.ts
import { Signal as Signal9 } from "@shared-ui/core-signal-manager/spi";
var TripItemUnsavedSignal = /*#__PURE__*/ function(Signal9) {
    "use strict";
    _inherits(TripItemUnsavedSignal, Signal9);
    function TripItemUnsavedSignal() {
        _class_call_check(this, TripItemUnsavedSignal);
        return _call_super(this, TripItemUnsavedSignal, arguments);
    }
    return TripItemUnsavedSignal;
}(Signal9);
// src/signals/trip-itinerary-template-changed.ts
import { Signal as Signal10 } from "@shared-ui/core-signal-manager/spi";
var TripItineraryTemplateChangedSignal = /*#__PURE__*/ function(Signal10) {
    "use strict";
    _inherits(TripItineraryTemplateChangedSignal, Signal10);
    function TripItineraryTemplateChangedSignal() {
        _class_call_check(this, TripItineraryTemplateChangedSignal);
        return _call_super(this, TripItineraryTemplateChangedSignal, arguments);
    }
    return TripItineraryTemplateChangedSignal;
}(Signal10);
// src/signals/trip-template-block-state.ts
import { Signal as Signal11 } from "@shared-ui/core-signal-manager/spi";
var TripTemplateBlockStateSignal = /*#__PURE__*/ function(Signal11) {
    "use strict";
    _inherits(TripTemplateBlockStateSignal, Signal11);
    function TripTemplateBlockStateSignal() {
        _class_call_check(this, TripTemplateBlockStateSignal);
        return _call_super(this, TripTemplateBlockStateSignal, arguments);
    }
    return TripTemplateBlockStateSignal;
}(Signal11);
// src/signals/trip-template-required-block-failed.ts
import { Signal as Signal12 } from "@shared-ui/core-signal-manager/spi";
var TripTemplateRequiredBlockFailedSignal = /*#__PURE__*/ function(Signal12) {
    "use strict";
    _inherits(TripTemplateRequiredBlockFailedSignal, Signal12);
    function TripTemplateRequiredBlockFailedSignal() {
        _class_call_check(this, TripTemplateRequiredBlockFailedSignal);
        return _call_super(this, TripTemplateRequiredBlockFailedSignal, arguments);
    }
    return TripTemplateRequiredBlockFailedSignal;
}(Signal12);
// src/signals/trip-toast.ts
import { Signal as Signal13 } from "@shared-ui/core-signal-manager/spi";
var TripToastSignal = /*#__PURE__*/ function(Signal13) {
    "use strict";
    _inherits(TripToastSignal, Signal13);
    function TripToastSignal() {
        _class_call_check(this, TripToastSignal);
        return _call_super(this, TripToastSignal, arguments);
    }
    return TripToastSignal;
}(Signal13);
// src/signals/trip-participants-changed.ts
import { Signal as Signal14 } from "@shared-ui/core-signal-manager/spi";
var TripParticipantsChangedSignal = /*#__PURE__*/ function(Signal14) {
    "use strict";
    _inherits(TripParticipantsChangedSignal, Signal14);
    function TripParticipantsChangedSignal() {
        _class_call_check(this, TripParticipantsChangedSignal);
        return _call_super(this, TripParticipantsChangedSignal, arguments);
    }
    return TripParticipantsChangedSignal;
}(Signal14);
// src/signals/save-item-prompt-button-clicked.ts
import { Signal as Signal15 } from "@shared-ui/core-signal-manager/spi";
var SaveItemPromptButtonClickedSignal = /*#__PURE__*/ function(Signal15) {
    "use strict";
    _inherits(SaveItemPromptButtonClickedSignal, Signal15);
    function SaveItemPromptButtonClickedSignal() {
        _class_call_check(this, SaveItemPromptButtonClickedSignal);
        return _call_super(this, SaveItemPromptButtonClickedSignal, arguments);
    }
    return SaveItemPromptButtonClickedSignal;
}(Signal15);
// src/signals/trip-note-action.ts
import { Signal as Signal16 } from "@shared-ui/core-signal-manager/spi";
var TripNoteActionSignal = /*#__PURE__*/ function(Signal16) {
    "use strict";
    _inherits(TripNoteActionSignal, Signal16);
    function TripNoteActionSignal() {
        _class_call_check(this, TripNoteActionSignal);
        return _call_super(this, TripNoteActionSignal, arguments);
    }
    return TripNoteActionSignal;
}(Signal16);
export { SaveItemPromptButtonClickedSignal, TripCreatedSignal, TripEntityDataUpdatedSignal, TripItemCommentChangedSignal, TripItemCommentCountChangedSignal, TripItemCountChangedSignal, TripItemCustomerNotificationSignal, TripItemDatesChangedSignal, TripItemSavedSignal, TripItemUnsavedSignal, TripItineraryTemplateChangedSignal, TripNoteActionSignal, TripParticipantsChangedSignal, TripTemplateBlockStateSignal, TripTemplateRequiredBlockFailedSignal, TripToastSignal };
//# sourceMappingURL=index.js.map